import Component from "../../classes/Component";
import {getChoice, resetChoice, updateCitiesByPhoneChange} from "../../helpers/_utilities";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";
import api from "../../api/instance";

const {customEventNames, classNames} = variables;
const formId = 'js-landing-feedback';
const phoneInputId = 'js-landing-partners-user-phone';
const cityInputId = 'js-landing-partners-user-city';

export default function () {

	return new Component({
		name: 'feedback',
		requiredTargets: ['#'+formId],
		onInit() {
            this.handlePhoneCountryChange = () => updateCitiesByPhoneChange('#'+phoneInputId, cityInputId);

            this.handleRequest = (detail) => {
                const {form, submitBtn} = detail;
                const postSelectSelector = '#'+(form.getAttribute('id'))+' [name="post"]';

                try {
                    const {notify, formValidation} = window?.currentPage?.components;
                    
                    $dom.addClass(submitBtn, classNames.lazyLoading);
            
                    api({
                        method: 'post',
                        url: form.getAttribute('action') || '/goodsRequest',
                        data: new FormData(form)
                    })
                        .then(({status, message}) => {
                            notify.show({
                                description: message,
                                status: status ? 'success' : 'error'
                            });
            
                            if (status) {
                                form.reset();
                                formValidation.validator && formValidation.validator.reset(form);
            
                                const postChoice = getChoice(postSelectSelector);
                                postChoice && resetChoice(postChoice, true);
                            }
                        })
                        .finally(() => $dom.removeClass(submitBtn, classNames.lazyLoading))
                } catch (e) {console.error(e)}
            }

            this.handleFormSubmit = ({detail}) => this.handleRequest(detail);

            $events.delegate
                .on(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
                .on('countrychange', '#'+phoneInputId, this.handlePhoneCountryChange)
        },
		onDestroy() {
            $events.delegate
                .off(customEventNames.validatedFormSubmit, '#'+formId, this.handleFormSubmit)
                .off('countrychange', '#'+phoneInputId, this.handlePhoneCountryChange)
        }
	})
}
